











































































































































































































































import moment from 'moment';

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';
import { validationMixin } from 'vuelidate'
import { required, requiredIf, minLength, sameAs } from 'vuelidate/lib/validators'

import { getFieldError } from '@/core/tools/forms/get_field_error';

import { STORE_KEY as PARENT_STORE_KEY } from '../../ShiftVDP/_store';
import { STORE_KEY, store } from './_store';

import IncidentCombobox from '@/components/Controls/IncidentCombobox.vue';

@Component({
  mixins: [ validationMixin ],
  computed: {
    ...mapState(PARENT_STORE_KEY, [
      'prevDocumentId'
    ]),
    ...mapState(STORE_KEY, [
      'loaded', 'loading', 'fatalError',
      'document', 'form', 'meta', 'forms'
    ]),
    ...mapGetters(STORE_KEY, [
      'fields'
    ])
  },
  methods: {
    getFieldError
  },
  components: {
    IncidentCombobox
  },
  validations() {
    const rules: any = {
      shift_id: {  },
      plan_id: {  },
      container_id: {  },
      datetime: {  },
      moment: {  },
      termocamera: {  },
      direct_palete: {  },
      row_number: {  },
      bucket_number: {  },
      temp: {  },
      acidity: {  },
      fat_id: {  },
      elasticity_id: {  },
      causticity_id: {  },
      characteristic: {  },
      gas_formation: {  },
      incident_type_id: {  },
      incident_sub_type_id: {  },
    }

    return {
      form: rules
    }
  }
})
export default class ShiftClotsMultiForm extends Vue {
  @Prop({ type: Boolean }) isNew!: boolean;
  @Prop({ type: Object }) documentPreview!: any;
  @Prop({ type: Object }) initParams!: any;
  @Prop({ type: String }) documentId!: any;
  @Prop({ type: String }) prevDocumentId!: any;

  document!: any
  form!: any
  prevPlansList!: any
  activeTab: number = 0

  row_count: number|null = null
  bucket_count: number|null = null
  container_id_dub: number|null = null

  toggles: any[] = []

  termocameras: any[] = [
    {id: 1, label: '1'},
    {id: 2, label: '2'},
    {id: 3, label: '3'},
  ]

  directs: any[] = [
    {id: 'up', label: 'верх'},
    {id: 'dowm', label: 'низ'},
  ]

  public isSuggestionsFetching = false;
  public suggestions: any[] = [];
  docIds: any[] = [];

  get newDay(){
    return moment().hours()  < 9;
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }
  public showed(r: any, b: any) {
    return this.toggles[r] ? this.toggles[r][b] : false;
  }
  public toggle(r: any, b: any) {
    if (!this.toggles[r]) {
      this.toggles[r] = [];
    }
    this.toggles[r][b] = !(this.toggles[r] ? this.toggles[r][b] : false)
    this.activeTab = this.activeTab + 1
    this.activeTab = this.activeTab - 1
  }

  public row_label(num: string, max: number) {
    let _lbl = '';
    switch(num) {
      case '1':
        _lbl = '1 - верхний'
        break;
      case '2':
        _lbl = '2 (сверху)'
        break;
      case '3':
        _lbl = (max > 3) ? '3 (сверху)' : '3 - нижний'
        break;
      case '4':
        _lbl = '4 (сверху)'
        break;
      case '5':
        _lbl = '5 - нижний'
        break;

    }
    return 'Ряд №' + _lbl
  }

  public mounted() {
    if (this.isNew) {
      this.$store.dispatch(`${STORE_KEY}/prepareNew`, this.initParams);
    } else {
      this.$store.dispatch(`${STORE_KEY}/init`, {
        id: this.documentPreview.id
      });
    }
    this.setDocIds()
  }

  @Watch('prevDocumentId')
  setDocIds() {
    this.docIds = [this.documentId]
    if (this.prevDocumentId) {
      this.docIds.push(this.prevDocumentId);
      
    }
  }


  changeValue(field: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/changeFormValue`, {
      field, newValue: value
    });

    // @ts-ignore
    // this.$v.form[field].$touch();
    // this.$v.form.$touch();
  }

  changeValueForms(row: number, bucket: number, field: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/changeFormValueForms`, {
      row, bucket,
      field, newValue: value
    });

    // @ts-ignore
    // this.$v.form[field].$touch();
    // this.$v.form.$touch();
  }

  onContainerChange($event: any) {
    this.row_count = 0;
    if ($event && $event.label) {
      this.row_count = $event.row_count;
      this.bucket_count = $event.bucket_count;
      this.$store.dispatch(`${STORE_KEY}/getenrateForms`, {
        row_count: this.row_count,
        bucket_count: this.bucket_count,
        starter_type_code: $event.starter_type_code,
      })
    }
  }

  onPlanVDPChange($event: any) {
    this.row_count = 0;
    if ($event && $event.label) {
      this.row_count = $event.row_count;
      this.bucket_count = $event.bucket_count;
      this.form.container_id = $event.container_id
      this.$store.dispatch(`${STORE_KEY}/getenrateForms`, {
        row_count: this.row_count,
        bucket_count: this.bucket_count,
        starter_type_code: $event.starter_type_code,
      })
    }
  }

  saveFormData() {
    this.$v.form.$touch()

    if(!this.$v.form.$error) {
      this.$store.dispatch(`${STORE_KEY}/saveForm`, this.documentPreview ? this.documentPreview.id : null)
      .then((result) => {
        this.$buefy.snackbar.open(`Данные успешно сохранены`);
        this.$v.form.$reset();

        this.$emit('form-close');
        (this.$parent as any).close();
      })
      .catch(() => {
        this.$buefy.snackbar.open({
          type: 'is-warning',
          message: `При сохранении возникли проблемы. Попробуйте позже.`
        })
      })
    }

  }

  beforeDestroy() {
    this.$store.dispatch(`${STORE_KEY}/reset`);
    // this.$store.unregisterModule(STORE_KEY);
  }
}

